import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SparklesIcon, HeartIcon, SunIcon, FeatherIcon, CompassIcon, MusicIcon } from 'lucide-react';
const modules = [{
  icon: SparklesIcon,
  title: 'Identidad Sagrada',
  description: 'Quién eres más allá del rol'
}, {
  icon: HeartIcon,
  title: 'Energía Femenina',
  description: 'Tu poder más profundo'
}, {
  icon: SunIcon,
  title: 'Abundancia Consciente',
  description: 'La relación con el dinero'
}, {
  icon: FeatherIcon,
  title: 'Sanación y Liberación',
  description: 'Soltar lo que ya no eres'
}, {
  icon: CompassIcon,
  title: 'Propósito Profundo',
  description: 'Tu misión en el mundo'
}, {
  icon: MusicIcon,
  title: 'Expansión Continua',
  description: 'Audios y transmisiones mensuales'
}];
const testimonials = [{
  quote: 'Alma en Expansión me devolvió a mí misma. No sabía cuánto necesitaba este espacio hasta que lo encontré.',
  name: 'Laura M.',
  location: 'España'
}, {
  quote: 'Cada audio, cada práctica, me lleva más profundo. Es mi ritual sagrado de cada día.',
  name: 'Carolina S.',
  location: 'México'
}];
export function AlmaEnExpansion() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="alma" ref={ref} className="py-24 md:py-32 bg-gradient-to-b from-beige to-cream" data-id="element-37">
      <div className="max-w-6xl mx-auto px-6" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 1.2,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-39">
          <motion.div initial={{
          scale: 0
        }} animate={isInView ? {
          scale: 1
        } : {}} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="w-20 h-20 mx-auto mb-8 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-40">
            <HeartIcon className="w-10 h-10 text-gold" data-id="element-41" />
          </motion.div>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-6" data-id="element-42">
            Alma en Expansión
          </h2>
          <p className="font-sans text-xl text-charcoal-mid font-light max-w-2xl mx-auto mb-4" data-id="element-43">
            Un espacio sagrado para tu expansión interior.
          </p>
          <p className="font-sans text-lg text-charcoal-mid/80 font-light max-w-xl mx-auto" data-id="element-44">
            No es un curso. Es un portal.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 1,
        delay: 0.4
      }} className="bg-white/60 backdrop-blur-sm rounded-3xl p-8 md:p-12 mb-12" data-id="element-45">
          <p className="font-sans text-lg text-charcoal-mid text-center leading-relaxed max-w-3xl mx-auto" data-id="element-46">
            Aquí viven las prácticas, los audios, los rituales y las
            transmisiones que te llevan más profundo. Donde el negocio y el alma
            se encuentran.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-47">
          {modules.map((module, index) => <motion.div key={module.title} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.5 + index * 0.1,
          ease: 'easeOut'
        }} className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 text-center" data-id="element-48">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-49">
                <module.icon className="w-6 h-6 text-gold" data-id="element-50" />
              </div>
              <h3 className="font-serif text-xl text-charcoal mb-2" data-id="element-51">
                {module.title}
              </h3>
              <p className="font-sans text-sm text-charcoal-mid" data-id="element-52">
                {module.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 1
      }} className="bg-charcoal rounded-3xl p-8 md:p-12 mb-12" data-id="element-53">
          <div className="text-center mb-8" data-id="element-54">
            <p className="font-sans text-sm uppercase tracking-widest text-gold mb-2" data-id="element-55">
              Suscripción
            </p>
            <h3 className="font-serif text-2xl text-cream" data-id="element-56">
              Acceso mensual al portal sagrado
            </h3>
          </div>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-57">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-charcoal-mid/30 rounded-2xl p-6" data-id="element-58">
                <p className="font-sans text-cream/90 italic mb-4 leading-relaxed" data-id="element-59">
                  "{testimonial.quote}"
                </p>
                <p className="font-sans text-sm text-gold" data-id="element-60">
                  {testimonial.name}, {testimonial.location}
                </p>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 1.2
      }} className="text-center" data-id="element-61">
          <button className="px-10 py-4 bg-gold text-white font-sans font-medium rounded-full hover:bg-gold/90 transition-all duration-300 hover:shadow-lg hover:shadow-gold/20" data-id="element-62">
            Entrar al portal
          </button>
        </motion.div>
      </div>
    </section>;
}